import { ProfileSize } from './types';
import { TypographySize } from '../typography/types';
import { Size } from '@vtbhome/juicyfront/types';

export const TYPOGRAPHY_SIZE_MAP: Record<ProfileSize, TypographySize> = {
    m: 'subtitle3',
    s: 'body2_short',
};

export const AVATAR_WRAPPER_SIZE_MAP: Record<ProfileSize, number> = {
    m: 32,
    s: 20,
};

export const USER_ICON_SIZE_MAP: Record<ProfileSize, Size> = {
    m: 'xs',
    s: 'xxxs',
};

export const PHOTO_SIZE_MAP: Record<ProfileSize, Size> = {
    m: 's',
    s: 'xs',
};

export const WrapperStylesBySize = ({ size }: { size: ProfileSize }) => {
    switch (size) {
        case 'm': {
            return `
                padding: 4px 12px 4px 8px;
                gap: 12px;
                border-radius: 44px;
            `;
        }
        case 's': {
            return `
                padding: 4px 8px 4px 4px;
                gap: 4px;
                border-radius: 16px;
            `;
        }
        default: {
            return '';
        }
    }
};
